export default "__VITE_ASSET__Sr_4uj_u__"